// utils/downloadPDF.js

/**
 * Function to download a PDF from a provided URL
 * @param {string} url - The URL of the PDF file (can be local or external)
 * @param {string} filename - The name to save the file as
 */
export const downloadPDF = async (url, filename) => {
  try {
    // Fetch the PDF file from the given URL
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch PDF: ${response.statusText}`);
    }

    // Convert response to a Blob
    const blob = await response.blob();

    // Create a temporary URL for the Blob
    const downloadUrl = window.URL.createObjectURL(blob);

    // Create a temporary anchor element for downloading
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename; // Use the provided PDF file name

    // Append the link, trigger click, and remove it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Revoke the object URL to free memory
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('Error downloading PDF:', error);
    throw new Error('Unable to download the PDF. Please try again.');
  }
};
